// deprecated in favor of useMobileStatus.js
// (requires a switch from createReactClass to hooks)

export const MobileMixin = {
    getInitialState: function () {
        return {
            isMobile: false,
        };
    },

    componentDidMount: function () {
        $(window).on('orientationchange resize', this.setMobile);
        this.setMobile();
    },

    setMobile: function () {
        this.setState({
            // Defined in js/dc/general/mobileOrFullSite.js
            // eslint-disable-next-line no-undef
            isMobile: isMobileView(),
        });
    },
};
